/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  GamoraFoundationAdapterQuery,
  GamoraFoundationAdapterQueryArgs,
  GamoraFoundationAdapterQueryOperator,
} from '../query.js';
import { GamoraUUIDGuard } from '../../../guards/uuid.js';

/**
 * @public
 */
export type GamoraFoundationAdapterQueryRemoveOperand = [
  string,
  GamoraUUIDGuard,
];

/**
 * @public
 */
export type GamoraFoundationAdapterQueryRemoveResult = boolean;

/**
 * @public
 */
export type GamoraFoundationAdapterQueryRemoveArgs =
  GamoraFoundationAdapterQueryArgs<GamoraFoundationAdapterQueryRemoveOperand>;

/**
 * @public
 */
export class GamoraFoundationAdapterQueryRemove extends GamoraFoundationAdapterQuery<
  GamoraFoundationAdapterQueryRemoveOperand,
  GamoraFoundationAdapterQueryRemoveResult
> {
  protected override _operator: GamoraFoundationAdapterQueryOperator =
    GamoraFoundationAdapterQueryOperator.REMOVE;
  constructor(args: GamoraFoundationAdapterQueryRemoveArgs) {
    super(args);
  }

  /**
   * Constructs query
   * @param operand The operand
   */
  static override fromOperand(
    operand: GamoraFoundationAdapterQueryRemoveOperand,
    options?: any,
  ): GamoraFoundationAdapterQueryRemove {
    return new GamoraFoundationAdapterQueryRemove({
      operand,
      options,
    });
  }
}
